import ChatModel from 'realTimeApi/models/ChatModel';

export default (state, action, config) => {
  const currentResource =
    state[config.propName][action.payload.resourceId] || {};
  const currentResourceChats = currentResource.chats || {};
  const currentChat = currentResourceChats[action.payload.chatId] || {};
  const currentChatInfo = currentChat.chatInfo || {};

  return {
    ...state,
    [config.propName]: {
      ...state[config.propName],
      [action.payload.resourceId]: {
        ...currentResource,
        chats: {
          ...currentResourceChats,
          [action.payload.chatId]: {
            ...currentChat,
            chatInfo: new ChatModel({
              ...currentChatInfo,
              unreadMessagesIds: action.payload.unreadMessagesIds || [],
            }),
          },
        },
      },
    },
  };
};
